"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.solarWaterPumpingOffGridCal = void 0;
const calculator_1 = require("../calculator");
var convert = require('convert-units');
class solarWaterPumpingOffGridCal {
    static calculate(req) {
        const constants = req.solarWaterPumpingOffGridConstants;
        const emissionUnitParts = constants.emissionFactorUnit.split('/');
        if (emissionUnitParts.length != 2) {
            throw Error("Invalid emission factor unit " + constants.emissionFactorUnit);
        }
        const measuredUnitParts = req.energyGenerationUnit.split('/');
        if (measuredUnitParts.length != 3) {
            throw Error("Invalid measured unit " + req.energyGenerationUnit);
        }
        const unitX = convert(req.energyGeneration).from(measuredUnitParts[0]).to(emissionUnitParts[0]);
        return Number((constants.emissionFactor * unitX).toFixed(calculator_1.PRECISION));
    }
}
exports.solarWaterPumpingOffGridCal = solarWaterPumpingOffGridCal;
